import { StatePreV3, StateV3 } from './3_migrate_assekuranztarif.interface';

export const migrateAssekuranztarif = (previousState: StatePreV3, newVersion: number): StateV3 => {
  const newState = {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      isAssekuranztarif: previousState.versicherungsnehmer.isFinanzdienstleistertarif,
    },
  };
  delete newState.versicherungsnehmer.isFinanzdienstleistertarif;
  return newState;
};
